import { useEffect } from 'react';

import type { Column } from '../providers/BulkConfigureContextProvider.tsx';
import {
	useMappingsActions,
	useMappingsState,
	useProjectsState,
	useIssueTypesState,
} from '../providers/BulkConfigureContextProvider.tsx';
import { useIssueCreateSidePanelContext } from '../providers/IssueCreateSidePanelContextProvider.tsx';

export const useSetOptionsColumns = (): void => {
	const { setOptionsColumns, setColumnOffset } = useMappingsActions();
	const { mappingWorkItemTypes, mappingFieldAllowedValues } = useMappingsState();
	const { selectedIssueType } = useIssueTypesState();
	const { selectedProject } = useProjectsState();
	const [{ selectedTable }] = useIssueCreateSidePanelContext();
	const { mappingValidParentCandidates } = useMappingsState();

	useEffect(() => {
		if (selectedTable && selectedTable.rows.length > 0) {
			const columns: Column[] = [];
			// Always use the first row as the header row, even if it is not a HTML header row
			const firstRow = selectedTable?.querySelector('tbody tr:first-of-type');
			if (firstRow) {
				const firstRowCells = Array.from(firstRow.querySelectorAll('td, th'));
				const hasNumberedCol = firstRowCells[0].classList.contains(
					'ak-renderer-table-number-column',
				)
					? 1
					: 0;
				const hasHeaderCol =
					selectedTable.rows.length > 1 &&
					Array.from(selectedTable.rows).every(
						(row) =>
							row.cells.length > 1 &&
							(row.cells[0].tagName.toLowerCase() === 'th' ||
								row.cells[1].tagName.toLowerCase() === 'th'),
					)
						? 1
						: 0;
				// The API does not index the header column
				setColumnOffset(hasHeaderCol);
				let columnIndex = hasNumberedCol + hasHeaderCol;
				// Skip the header and numbered column
				firstRowCells.slice(hasNumberedCol + hasHeaderCol).forEach((cell) => {
					const column = { index: columnIndex, header: cell.textContent ?? '' };
					columns.push(column);
					columnIndex += 1;
				});
			}
			setOptionsColumns(columns);
		}
	}, [
		selectedTable,
		setColumnOffset,
		setOptionsColumns,
		mappingWorkItemTypes,
		selectedIssueType,
		selectedProject,
		mappingValidParentCandidates,
		mappingFieldAllowedValues,
	]);
};
